import styles from './CategoriesIconSection.module.scss';

export default function CategoriesIconSection(props) {
  return (
    <div className={`position-relative py-4 ${styles.categoryIconBox}`}>
      {
        props.data.map((category) => (
          <a 
            key={category.id} 
            href={`/product-list/${category.id}`} 
            className={`${styles.lgtCategoryIcon} text-decoration-none me-2 mb-2`}
            >
            <img src={`${!category.icon ? 'images.png' : `${process.env.REACT_APP_API_URL}${category.icon}`}`} className={`img-fluid`}/>
            <span className='text-white'>{category.title}</span>
          </a>
        ))
      }
    </div>
  )
}
